import { FE_URL, URL } from "../utils/constants.ts";

const localURL = "https://localhost:5001/api";

export async function login(loginData) {
  let url = `${URL}/Account/login`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(loginData),
  });

  if (!response.ok) {
    const error = new Error("An error occurred while logging in.");
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const data = await response.json();
  return data.token;
}

export async function sendResetToken(email) {
  let url = `${URL}/Account/forgot-password/${email}`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const error = new Error("An error occurred while logging in.");
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  await response.json();
}
export async function resetPass(data) {
  let url = `${URL}/Account/reset-password`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = new Error("An error occurred while logging in.");
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  await response.json();
}

export async function register(registerData) {
  let url = `${URL}/Account/register`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(registerData),
  });

  if (!response.ok) {
    const error = new Error("An error occurred while register.");
    error.code = response.status;
    error.info = await response.text();
    throw error;
  }

  const data = await response.text();

  return data;
}

export async function getAccountDetails(id) {
  let url = `${URL}/User/${id}`;

  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error(
      "An error occurred while fetching the account data"
    );
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const data = await response.json();

  return data;
}

export async function getAccountOrders(id) {
  let url = `${URL}/Order/orders/${id}`;

  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error(
      "An error occurred while fetching the account orders"
    );
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const data = await response.json();
  return data.reverse();
}
